// src/mobile/pages/Administration/StartFooter.tsx

import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "ru", label: "Русский" },
  { code: "tr", label: "Türkçe" },
  { code: "ar", label: "العربية" },
  { code: "hi", label: "हिन्दी" },
];

const StartFooter: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const currentLanguageCode =
    i18n.resolvedLanguage || i18n.language || "en";

  const currentLanguage =
    languages.find((language) =>
      currentLanguageCode.startsWith(language.code)
    )?.label || "English";

  return (
    <>
      <style>
        {`
          .mobile-start-footer {
            width: 100%;
            box-sizing: border-box;
            padding:
              22px 18px
              calc(22px + env(safe-area-inset-bottom));
            background: rgba(3, 7, 18, 0.97);
            border-top: 1px solid rgba(148, 163, 184, 0.16);
          }

          .mobile-start-footer-inner {
            width: 100%;
            max-width: 480px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 18px;
            color: #9ca3af;
            text-align: center;
          }

          .mobile-start-footer-brand {
            font-size: 12px;
            line-height: 1.5;
          }

          .mobile-start-footer-links {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 10px 18px;
          }

          .mobile-start-footer-actions {
            width: 100%;
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;
          }

          .mobile-start-footer-language {
            position: relative;
            grid-column: 1 / -1;
          }

          @media (max-width: 360px) {
            .mobile-start-footer-actions {
              grid-template-columns: 1fr;
            }

            .mobile-start-footer-language {
              grid-column: auto;
            }
          }
        `}
      </style>

      <footer className="mobile-start-footer">
        <div className="mobile-start-footer-inner">
         

          <nav
            className="mobile-start-footer-links"
            aria-label={t("home.footer.navigation", {
              defaultValue: "Footer navigation",
            })}
          >
            <button
              type="button"
              onClick={() => navigate("/legal/termsofuse")}
              style={footerLinkStyle}
            >
              {t("home.footer.links.termsOfUse")}
            </button>

            <button
              type="button"
              onClick={() => navigate("/legal/privacypolicy")}
              style={footerLinkStyle}
            >
              {t("home.footer.links.privacyPolicy")}
            </button>

            <button
              type="button"
              onClick={() => navigate("/helpsupportstart")}
              style={footerLinkStyle}
            >
              {t("home.footer.links.helpSupport")}
            </button>
          </nav>

          <div className="mobile-start-footer-actions">
            <a
              href="#"
              onClick={(event) => event.preventDefault()}
              style={storeButtonStyle}
              aria-label="Download on the App Store"
            >
              <span aria-hidden="true"></span>
              <span>App Store</span>
            </a>

            <a
              href="#"
              onClick={(event) => event.preventDefault()}
              style={storeButtonStyle}
              aria-label="Get it on Google Play"
            >
              <span aria-hidden="true">▶</span>
              <span>Google Play</span>
            </a>

            <div className="mobile-start-footer-language">
  <button
    type="button"
    onClick={() => navigate("/language")}
    style={languageButtonStyle}
    aria-label={t("language", {
      defaultValue: "Select language",
    })}
  >
    <span aria-hidden="true">🌐</span>
    <span>{currentLanguage}</span>
  </button>
  <div className="mobile-start-footer-brand">
            <span style={{ color: "#f8e298", fontWeight: 700 }}>
              Elnydo
            </span>

            <span style={{ marginLeft: 6 }}>
              · {t("home.footer.tagline")}
            </span>
          </div>
</div>
 
          </div>
        </div>
      </footer>
    </>
  );
};

const footerLinkStyle: React.CSSProperties = {
  minHeight: 34,
  padding: "6px 2px",
  border: "none",
  background: "transparent",
  color: "#9ca3af",
  cursor: "pointer",
  fontSize: 12,
  touchAction: "manipulation",
};

const storeButtonStyle: React.CSSProperties = {
  minHeight: 42,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 7,
  padding: "8px 12px",
  border: "1px solid rgba(148,163,184,0.34)",
  borderRadius: 999,
  background: "rgba(15,23,42,0.5)",
  color: "#e5e7eb",
  textDecoration: "none",
  fontSize: 12,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  touchAction: "manipulation",
};

const languageButtonStyle: React.CSSProperties = {
  width: "100%",
  minHeight: 42,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 7,
  padding: "8px 12px",
  border: "1px solid rgba(148,163,184,0.34)",
  borderRadius: 999,
  background: "rgba(15,23,42,0.5)",
  color: "#e5e7eb",
  cursor: "pointer",
  fontSize: 12,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  touchAction: "manipulation",
  marginBottom: "19px"
};

export default StartFooter;